var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAssessmentEvaluationPlayDefaultIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_PlayIcon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    d: "M18.125 20H1.875C0.8375 20 0 19.1625 0 18.125V1.875C0 0.8375 0.8375 0 1.875 0H18.125C19.1625 0 20 0.8375 20 1.875V18.125C20 19.1625 19.1625 20 18.125 20ZM1.875 1.25C1.525 1.25 1.25 1.525 1.25 1.875V18.125C1.25 18.475 1.525 18.75 1.875 18.75H18.125C18.475 18.75 18.75 18.475 18.75 18.125V1.875C18.75 1.525 18.475 1.25 18.125 1.25H1.875Z",
    fill: "#DE1186"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PlayIcon",
    d: "M7 5L14 10L7 15V5Z",
    fill: "#DE1186"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssessmentEvaluationPlayDefaultIcon);
export default __webpack_public_path__ + "static/media/assessment-evaluation-play-default-icon.fe19f0cb267ad3a92d16352c923998be.svg";
export { ForwardRef as ReactComponent };